import api from "./api"

const fileUploadService = {
    uploadFile: async (payload) => {
        const response = await api.post('/api/file-upload', payload, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    },

};

export default fileUploadService;